import { SNOWPLOW_ENDPOINTS, SNOWPLOW_STANDS, SNOWPLOW_SCRIPT_URL, SNOWPLOW_TRACKER_URL } from '~/shared/const/snowplow'
import { ENVIRONMENT_STANDS, type EnvironmentStand } from '~/shared/const/environment-stands'
import { CMO_ENDPOINTS, CMO_SCRIPT_URL } from '~/shared/const/cmo'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()
  const stand = runtimeConfig.public.environmentStand as EnvironmentStand

  if (!stand || !ENVIRONMENT_STANDS[stand]) return

  const baseUrl = ENVIRONMENT_STANDS[stand]
  const spScriptUrl = `${baseUrl}${SNOWPLOW_SCRIPT_URL}`
  const spTrackerUrl = `${baseUrl}${SNOWPLOW_TRACKER_URL}`
  const cmoScriptUrl = `${baseUrl}${CMO_SCRIPT_URL}`

  const spEnvScript = `
    ;(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[]; p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments) };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1; n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script","${spScriptUrl}","snowplow"));

    snowplow('newTracker', 'events', '${SNOWPLOW_ENDPOINTS[stand]}', {
      appId: '${SNOWPLOW_STANDS[stand]}',
      discoverRootDomain: true,
      cookieSameSite: 'Lax',
      contexts: {
        webPage: true
      }
    });
  `

  const cmoEnvScript = `
    const PersPlugin = {
        PersPlugin: function() {
            return {
                beforeTrack: (payload) => {
                    const data = window.cmo.getDataFromPayloadBuilder(payload);
                    if ("event_data" in data && "eventAction" in data.event_data && data.event_data.eventAction === 'activityPageVisit') {
                        const client = new window.cmo.CMOPersonalisationClient('${CMO_ENDPOINTS[stand]}', 'POP-UP', {
                            "duid": data.duid
                        }, {
                            context: data
                        });
                        const contactPoint = new window.cmo.PopupContactPoint('svoevagro.ru', {
                            responseEventSchema: 'iglu:rp/popup-response/jsonschema/1-0-0',
                            responseEventContext: () => ({
                                platform: 'sa',
                                eventCategory: 'popupResponse',
                            })
                        });
                        client.registerContactPoint(contactPoint);
                        client.fetchAndApplyContent();
                    }
                    payload.build()
                }
            }
        }
    };
    window.snowplow('addPlugin:events', PersPlugin, 'PersPlugin')
  `

  // tagPriority фиксирует порядок тегов: unhead иначе поднимает async-скрипты выше
  // инлайновых, а rptracker.js и CMO-скрипт рассчитывают на уже созданный window.snowplow
  useHead({
    script: [
      { innerHTML: spEnvScript, tagPriority: 1 },
      { src: cmoScriptUrl, async: true, tagPriority: 2 },
      { src: spTrackerUrl, async: true, tagPriority: 3 },
      { innerHTML: cmoEnvScript, tagPriority: 4 },
    ],
  })
})
